import { render, staticRenderFns } from "./DefaultAcademicYear.vue?vue&type=template&id=07097b30&"
import script from "./DefaultAcademicYear.vue?vue&type=script&lang=js&"
export * from "./DefaultAcademicYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports